import styled from '@emotion/styled';

export const TooltipWrapper = styled.span`
    display: inline-block;
`;
